import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import useStyles from './AdditionalText.styled'

export const useAdditionalText = props => {
	const {
		mataText,
		textMetaKey,
		metaButtonText,
		buttonTextMetaKey,
		metaButtonAction,
		buttonButtonLink,
		sm,
		md,
		className,
	} = props

	const classes = useStyles(props)
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaButtonAction })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: mataText })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: mataText,
		key: textMetaKey,
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaButtonText,
		key: buttonTextMetaKey,
	})

	return [
		{
			className,
			classes,
			sm,
			md,

			text: mataText?.metaValue,
			textKey: mataText?.tierKey,
			textConfig: mataText?.config,
			textEditable,

			buttonText: metaButtonText?.metaValue,
			buttonTextKey: metaButtonText?.tierKey,
			buttonTextConfig: metaButtonText?.config,
			buttonAction: metaButtonAction?.metaValue,
			buttonLink: buttonButtonLink?.metaValue,
			buttonTextEditable,
		},
		{
			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,
		},
	]
}
